import type { ScriptStep, UserInputMode } from '@shared/interfaces/assistantScripts';

export const msToSeconds = (
  items: (ScriptStep & { delayBeforeAdvancingMs: number })[],
): ScriptStep[] =>
  items.map((item) => ({
    ...item,
    delayBeforeAdvancing: (item.delayBeforeAdvancingMs || 0) / 1000,
  }));

export const secondsToMs = (items: ScriptStep[]): ScriptStep[] =>
  items.map(({ delayBeforeAdvancing, ...item }) => ({
    ...item,
    delayBeforeAdvancingMs: (delayBeforeAdvancing || 0) * 1000,
  }));

export const getUserInputMode = (step: ScriptStep): UserInputMode => {
  if (step.awaitButtonNext) {
    return 'button_next';
  }

  if (step.enableClickAnywhere) {
    return 'click_anywhere';
  }

  if ((step.allowedKeys?.length ?? 0) > 0) {
    return 'keyboard';
  }

  return 'none';
};
